import http from '@/utils/http';

const call = async (action, data) => {
  const response = await http({ url: `/api/admin/v1/contractOrderAmendment/${action}`, data, method: 'post' });
  if (response?.code !== 0 || !response.data) throw Error(response?.msg || response?.message || '子单变更请求失败，请重试');
  return response.data;
};

export default Object.fromEntries([
  'context', 'preview', 'propose', 'detail', 'confirm', 'reject', 'withdraw', 'tasks',
  'prepareFunds', 'submitFunds', 'fundsDetail',
].map(action => [action, data => call(action, data)]));
